export const LOGIN = '/api/auth/v1/sign-in';
export const REGISTER = '/api/auth/v1/sign-up';
export const FORGET_PASSWORD = '/api/auth/v1/forget-password';
export const RESET_PASSWORD = '/api/auth/v1/reset-password';
export const CHECK_RESET_TOKEN = '/api/auth/v1/check-reset-token';
export const CHECK_INVITE_TOKEN = '/api/v1/invitation/check-invite-user-token';
